import { motion } from 'motion/react';

import { ANSWER_SECTIONS, answerSectionId } from '@src/corelib/seo/answerSections';
import { formatUpdated } from '@src/corelib/seo/dates';
import { ROUTE_META } from '@src/corelib/seo/routeMeta';

// Answer-first overview under a page hero: the question as H2 plus one brand-free definition (SEO-82).
export default function AnswerSection({ path }) {
  const entry = ANSWER_SECTIONS[path];
  if (!entry) {
    return null;
  }

  const id = answerSectionId(path);
  const updated = ROUTE_META[path]?.updated;

  return (
    <section aria-labelledby={id} className="py-12 lg:py-16 bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-12 items-start"
        >
          <div className="lg:col-span-5">
            <h2 id={id} className="text-2xl lg:text-3xl font-bold text-gray-900 leading-tight">
              {entry.question}
            </h2>

            {updated && (
              <p className="mt-2 text-sm text-gray-500">
                Updated
                {' '}
                <time dateTime={updated}>{formatUpdated(updated)}</time>
              </p>
            )}
          </div>

          <p className="lg:col-span-7 text-lg text-gray-600 leading-relaxed">
            {entry.definition}
          </p>
        </motion.div>
      </div>
    </section>
  );
}
